var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      class: `font-josefin font-semibold text-${_vm.colour}-600 disabled:text-gray-200 tracking-wider text-sm uppercase px-6 py-3 border-solid border-2 border-${_vm.colour}-600 disabled:border-gray-200 inline-block hover:bg-${_vm.colour}-600 disabled-hover:bg-white hover:text-white my-2 sm:my-4 transition ease-in-out duration-150`,
      attrs: { type: _vm.type, disabled: _vm.disabled },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }